import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Trust from "@/components/landing/Trust";
import HowItWorks from "@/components/landing/HowItWorks";
import WhyMamaMatch from "@/components/landing/WhyMamaMatch";
import Screenshots from "@/components/landing/Screenshots";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-root" className="relative bg-white">
      <Navbar />
      <Hero />
      <Trust />
      <HowItWorks />
      <WhyMamaMatch />
      <Screenshots />
      <Testimonials />
      <Faq />
      <Footer />
    </main>
  );
}
